export default __webpack_public_path__ + "static/media/tuto_kingdom_4_1x.b397da7e.webp";